<template>
    <div class="Background">
        <v-container fluid>
        <v-row no-gutters class="uniform-gap-32">
            <!-- 좌측 컬럼: 플레이어 + 소셜미디어 -->
            <v-col
                cols="12" md="7" xl="8" class="grid-col"
            >
            <!-- 플레이어 카드 -->
            <div class="video-container mb-4">
                <iframe
                    scrolling="no"
                    ref="iframe"
                    :src="EMBEDIEDURL"
                    frameborder="0"
                    allowfullscreen
                    @load="temp"
                    @playing="resizeVideo"
                ></iframe>
            </div>

            <!-- 플레이어 아래 새로고침/안내 -->
            <v-alert class="info_alert" type="info" dense text>
                <span>{{ $store.getters.t('새로고침 버튼을 눌러주셔야 라이브 방송이 스트림온에 반영됩니다.') }}</span>
                <template v-slot:append>
                    <v-btn small icon color="blue darken-2" @click="refreshIframe">
                    <v-icon>mdi-refresh</v-icon>
                    </v-btn>
                </template>
            </v-alert>

            <!--소셜미디어 스트리밍 UI-->
            <SocialLiveStreamingCard
                :standardVal="standardVal"
                :context="liveRelayContext"
                :liveInfo="socialLiveInfo"
                source-type="wowza"
            />

            </v-col>

            <!-- 우측 컬럼: 스트리밍 상세 정보 + URL INFO -->
            <v-col
            cols="12" md="5" xl="4" class="grid-col"
            >
            <!-- 스트리밍 상세 정보 -->
            <v-card class="rounded-lg elevation-0 mb-6">
                <v-card-title class="py-4 d-flex justify-space-between py-4">
                    <h3 class="tabletitle pb-0">{{ $store.getters.t('스트리밍 상세 정보') }}</h3>
                    <div>
                        <TextButton :buttonText="$store.getters.t('목록')" @click="goLiveList()" class="mr-2"/>
                        <TextButton :buttonText="$store.getters.t('저장')" isPrimary @click="saveChanges" :loading="saveLoading"/>    
                    </div>
                    </v-card-title>
                <v-divider />

                <v-card-text class="pt-4">
                <v-simple-table>
                    <template v-slot:default>
                    <thead>
                        <tr>
                        <th class="thead_custom_left thead_custom_top pa-3" style="height: 60px;">
                            {{ $store.getters.t('Live 스트리밍') }}
                        </th>
                        <th class="thead_custom_right thead_custom_top pa-3">
                            <span>
                            <Input placeholder="name" :value="displayStreamName" viewType="name" :disabled="true" />
                            </span>
                        </th>
                        </tr>
                        <tr>
                        <th class="thead_custom_left pa-3" style="height: 66px;">
                            {{ $store.getters.t('퍼블리싱') }}
                        </th>
                        <th class="thead_custom_right pa-3">
                            <CustomSwitch :switchState="switchStates.publishing" :toggleSwitch="() => toggleSwitch('publishing')" />
                        </th>
                        </tr>
                        <tr>
                        <th class="thead_custom_left pa-3" style="height: 66px;">
                            {{ $store.getters.t('레코딩') }}
                        </th>
                        <th class="thead_custom_right pa-3" style="display:flex;align-items:center;">
                            <CustomSwitch :switchState="switchStates.recording" :toggleSwitch="() => toggleSwitch('recording')" />
                            <span v-if="recorderState === 'stop'" class="reco_status recording_off">
                            <v-icon x-small class="mdi mdi-square mr-1" color="#999" />
                            {{ $store.getters.t('녹화 중이 아닙니다') }}
                            </span>
                            <span v-if="recorderState === 'progress'" class="reco_status recording_on">
                            <v-icon x-small class="mdi mdi-circle mr-1 blinking" color="#d33333" />
                            {{ $store.getters.t('녹화 중입니다') }}
                            </span>
                            <span v-if="recorderState === 'wait'" class="reco_status recording_waiting">
                            <v-icon small class="mdi mdi-clock-outline mr-1" color="#d33333" />
                            {{ $store.getters.t('영상을 준비하는 중입니다') }}
                            </span>
                        </th>
                        </tr>
                    </thead>
                    </template>
                </v-simple-table>
                </v-card-text>
            </v-card>

            <!-- URL INFO -->
            <v-card class="rounded-lg elevation-0">
            <v-card-title class="py-4 d-flex justify-space-between align-center">
                <h3 class="tabletitle pb-0">{{ $store.getters.t('INFO') }}</h3>
                <TextButton
                :buttonText="$store.getters.t('다운로드')"
                iconColor="#555"
                icon="mdi-download"
                class="ml-2"
                @click="downloadForm"
                />
            </v-card-title>
            <v-divider />

            <v-card-text class="pt-4">

            <!-- URL 항목들 -->
            <div class="url-info-list">

            <!-- OnPublish Server -->
            <div class="url-block">
                <div class="url-label">{{ $store.getters.t('OnpublishServer') }}</div>
                <div class="url-line">
                <div class="url-text mono-ellipsis" :title="OnpublishServer">{{ OnpublishServer }}</div>
                <v-btn icon color="#999" @click="copyToClipboard(OnpublishServer)">
                    <v-icon small>mdi-content-copy</v-icon>
                </v-btn>
                </div>
            </div>

            <!-- Stream Key -->
            <div class="url-block">
                <div class="url-label">{{ $store.getters.t('StreamKey') }}</div>
                <div class="url-line">
                <div class="url-text mono-ellipsis" :title="stream_name">{{ stream_name }}</div>
                <v-btn icon color="#999" @click="copyToClipboard(stream_name)">
                    <v-icon small>mdi-content-copy</v-icon>
                </v-btn>
                </div>
            </div>

            <!-- Playback URL -->
            <div class="url-block">
                <div class="url-label">{{ $store.getters.t('PLAYBACK URL') }}</div>
                <div class="url-line">
                <div class="url-text mono-ellipsis" :title="HLS">{{ HLS }}</div>
                <v-btn icon color="#999" @click="copyToClipboard(HLS)">
                    <v-icon small>mdi-content-copy</v-icon>
                </v-btn>
                </div>
            </div>

            <!-- Embedded URL -->
            <div class="url-block">
                <div class="url-label">{{ $store.getters.t('EMBEDDED URL') }}</div>
                <div class="url-line">
                <div class="url-text mono-ellipsis" :title="EMBEDIEDURL">{{ EMBEDIEDURL }}</div>
                <v-btn icon color="#999" @click="copyToClipboard(EMBEDIEDURL)">
                    <v-icon small>mdi-content-copy</v-icon>
                </v-btn>
                </div>
            </div>

            <!-- Thumbnail URL -->
            <div class="url-block">
                <div class="url-label">{{ $store.getters.t('THUMBNAIL URL') }}</div>
                <div class="url-line">
                <div class="url-text mono-ellipsis" :title="ThumbnailUrl">{{ ThumbnailUrl }}</div>
                <v-btn icon color="#999" @click="copyToClipboard(ThumbnailUrl)">
                    <v-icon small>mdi-content-copy</v-icon>
                </v-btn>
                </div>
            </div>

            <!-- RTMP URL (조건부) -->
            <div class="url-block" v-if="RTMP">
                <div class="url-label">RTMP URL</div>
                <div class="url-line">
                <div class="url-text mono-ellipsis" :title="RTMP">{{ RTMP }}</div>
                <v-btn icon outlined color="#999" @click="copyToClipboard(RTMP)">
                    <v-icon small>mdi-content-copy</v-icon>
                </v-btn>
                </div>
            </div>

            </div>
        </v-card-text>
            </v-card>
            </v-col>
        </v-row>
        </v-container>

        <!-- 스낵바 -->
        <AppSnackbar :message="snackbarText" :visible="snackbar" :error="snackbarError" />
    </div>
</template>

<script>
import Input from '@/components/ui/form/FormInput.vue';
// import TextButton from '@/components/ui/button/TextButton2.vue';
import TextButton from '@/components/ui/button/TextButton.vue';
import TextButtonBlock from '@/components/ui/button/TextButtonBlock.vue';
import AppDialog from '@/components/app/AppDialog.vue';
import CustomSwitch from '@/components/ui/switch/CustomSwitch.vue';
import IconButton from '@/components/ui/button/IconButton.vue';
import LiveStreamApi from "@/api/livestream/LiveStreamApi";
import AppSnackbar from "@/components/ui/snackbar/Snackbar.vue";
import { mapActions, mapState } from 'vuex';
import JSZip from 'jszip';
import SocialLiveStreamingCard from '@/components/socialupload/SocialLiveStreamingCard.vue';

export default {
    components: {
        Input,
        TextButton,
        CustomSwitch,
        IconButton,
        AppSnackbar,
        AppDialog,
        TextButtonBlock,
        SocialLiveStreamingCard
    },
    data() {
        return {
            stream_name: '',
            stream_name_by_user: '',
            //OnpublishServer: '',
            application: '',
            // switchStates: {
            //     publishing: false,
            //     recording: false,
            // },
            live_status: '',
            saveLoading: false,
            snackbar: false,
            snackbarText: '',
            snackbarError: false,
            recorderState: '',
            isChannelModalOpen: false,
            selectedPlatform: null,
            isProceeding: false,
        }
    },
    computed: {
        EMBEDIEDURL() {
            return `${window.location.protocol}//${window.location.host}/player?` + this.HLS;
            // return '';
        },
        HLS() {
            return 'https://' + this.cname + '/' + this.application + '/_definst_/' + this.stream_name + '/playlist.m3u8';
        },
        ThumbnailUrl() {
            return 'https://' + this.wowzaOrigin + ':8086/thumbnail?application=' + this.application + '&streamname=' + this.stream_name + '&size=640x360&fitmode=letterbox'
        },
        displayStreamName() {
            return this.stream_name_by_user !== null && this.stream_name_by_user !== undefined && this.stream_name_by_user !== ''
                ? this.stream_name_by_user
                : this.stream_name;
        },

        ...mapState('livestatus', {
            switchStates: state => state.switchStates
        }),
        isPublishing() {
            return this.switchStates ? this.switchStates.publishing : false;
        },
        isRecording() {
            return this.switchStates ? this.switchStates.recording : false;
        },
        //OnpublishServer = 'rtmp://' + this.wowzaOrigin + '/' + this.application + '/';
        OnpublishServer() {
            return 'rtmp://' + this.wowzaOrigin + '/' + this.application + '/';
        },
        standardVal() {
            const getStd = this.$store.getters['objectData/getStandard'];
            const privacy = getStd ? getStd('privacyData') : [];
            const categories = getStd ? getStd('youtubeCat') : [];
            return {
                privacyData: privacy.map(p => (typeof p === 'object' ? p : { label: String(p), value: p })),
                youtubeCat: categories.map(c => (typeof c === 'object' ? c : { label: String(c), value: c })),
            };
        },
        liveRelayContext() {
            const uuid = this.$route.params.uuid;
            return uuid ? `wowza:${uuid}` : null;
        },
        socialLiveInfo() {
            if (!this.stream_name) {
                return null;
            }
            return {
                uuid: this.$route.params.uuid,
                stream_name: this.stream_name,
                stream_name_by_user: this.stream_name_by_user,
                play_url: this.HLS,
                publish_url: this.OnpublishServer,
                type: 'wowza',
                appType: this.application,
                live_status: this.live_status,
            };
        }
    },
    methods: {
        ...mapActions('livestatus', ['toggleSwitch', 'saveSettings']),
        goLiveList(){
            this.$router.push('/wowzastream/wowzalivestream_create');
        },
        async pullStatus() {
            try {
                const data = {
                    recorderName: this.stream_name,
                    application: this.application
                }
                const response = await LiveStreamApi.checkStatus(data);
                console.log("res => ", response)
                if (response.status === '1') {
                    if (response.recorderState === 'Waiting for stream') {
                        this.recorderState = 'wait';
                    } else if (response.recorderState === 'Recording in Progress') {
                        this.recorderState = 'progress';
                    } else {
                        this.recorderState = 'stop';
                    }
                } else if (response.status === '2') {
                    this.recorderState = 'stop';
                }

            } catch (error) {
                console.error('Error', error);
            }
        },
        downloadForm(){
            const serviceJson = {
                settings: {
                    bwtest: false,
                    server: this.OnpublishServer,
                    key: this.stream_name
                },
                type: 'rtmp_custom'
            };

            const streamEncoderJson = {
                bitrate: 3000,
                keyint_sec: 0,
                preset: "superfast",
                profile: "baseline",
                tune: "zerolatency"
            };

            const basicIni = `[General]
Name=${this.stream_name}

[Video]
BaseCX=1920
BaseCY=1080
OutputCX=1280
OutputCY=720

[Panels]
CookieId=4B5DBA2A26ABE39E

[Output]
Mode=Advanced

[SimpleOutput]
StreamEncoder=x264
Preset=veryfast

[AdvOut]
TrackIndex=1
RecType=Standard
RecTracks=1
FLVTrack=1
FFOutputToFile=true
FFFormat=
FFFormatMimeType=
FFVEncoderId=0
FFVEncoder=
FFAudioMixes=1
RecSplitFileType=Time
Encoder=obs_x264
`;

            const zip = new JSZip();

            zip.file('service.json', JSON.stringify(serviceJson, null, 2));
            zip.file('streamEncoder.json', JSON.stringify(streamEncoderJson, null, 2));
            zip.file('basic.ini', basicIni);

            zip.generateAsync({ type: "blob" }).then((blob) => {
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = this.stream_name + '.zip';
                link.click();
            });
        },
        async saveChanges() {
            this.saveLoading = true;
            const frontUrl = `${window.location.protocol}//${window.location.host}`;
            const uuid = this.$route.params.uuid;
            const data = {
                ip: frontUrl,
                uuid: uuid,
                publishing: this.switchStates ? this.switchStates.publishing : false,
                recording: this.switchStates ? this.switchStates.recording : false,
                stream_name: this.stream_name
            };
            //console.log('data', data);
            const success = await this.$store.dispatch('livestatus/saveSettings', data);
            if (success) {
                this.$emit('settingsSaved');
                this.saveLoading = false;
                this.snackbar = true;
                this.snackbarText = this.$store.getters.t('정보 수정에 성공했습니다.');
                this.snackbarError = false;

                setTimeout(() => {
                    this.snackbar = false;
                    this.snackbarText = '';
                    // this.$router.go();
                }, 2000);
            }
        },
        copyToClipboard(textToCopy) {

            if(!textToCopy){
                this.snackbar = true;
                this.snackbarText = this.$store.getters.t('복사할 텍스트가 없습니다.');
                this.snackbarError = true;
                setTimeout(() => {
                    this.snackbar = false;
                    this.snackbarError = false;
                    this.snackbarText = "";
                }, 2000);

                return;
            }

            this.$copyText(textToCopy)
                .then(() => {
                    this.snackbar = true;
                    this.snackbarText = this.$store.getters.t('텍스트가 복사되었습니다');
                    this.snackbarError = false;
                    setTimeout(() => {
                        this.snackbar = false;
                        this.snackbarText = "";
                    }, 2000);
                })
                .catch(() => {
                    alert('Failed to copy text.');
                });
        },
        refreshIframe() {
            this.refresh();
            const originalURL = this.EMBEDIEDURL;
            this.$refs.iframe.src = '';
            this.$nextTick(() => {
                this.$refs.iframe.src = originalURL;
                const video =  this.$refs.iframe.contentWindow.document.querySelector('video');
                video.autoplay = true;
                video.play();
            });
        },
        async liveData(uuid) {
            try {
                const frontUrl = `${window.location.protocol}//${window.location.host}`;
                const data = {
                    ip: frontUrl,
                    uuid: uuid,
                };
                const response = await LiveStreamApi.detailApi(data);
                this.stream_name = response.item.stream_name;
                this.stream_name_by_user = response.item.stream_name_by_user;
                this.live_status = response.item.live_status;
                this.application = response.item.application;
                this.switchStates.publishing = response.item.pb_accept == '1';
                this.switchStates.recording = response.item.record_status == '1';
                this.cname = response.domain;

            } catch (error) {
                console.error('error', error);
            }
        },
        temp() {
            const iframe = this.$refs.iframe;
            const video = iframe.contentWindow.document.querySelector('video');
            if (!video) return;
            video.poster = "/streamon.png";
        },
        resizeVideo() {
            const iframe = this.$refs.iframe;
            const video = iframe.contentWindow.document.querySelector('video');
            const iframeDocument = iframe.contentWindow.document;
            if (!video) return;

            const container = iframe.parentElement;
            const containerWidth = container.offsetWidth;
            const videoWidth = video.videoWidth;
            const videoHeight = video.videoHeight;
            const aspectRatio = videoWidth / videoHeight;

            if (aspectRatio < 1) {
                container.style.paddingBottom = `${(videoHeight / videoWidth) * 100}%`;
            } else {
                container.style.paddingBottom = '56.25%';
            }

            video.autoplay = true;
            video.play();

        },
        refresh() {
            const uuid = this.$route.params.uuid;
            this.liveData(uuid);
            this.pullStatus();
        },
        async getApplication() {

            try {
                const response = await LiveStreamApi.getApplicationApi();
                //console.log('res', response.wowza);
                if (response.status === 1) {
                    //const applicationData = response.application;
                    //const wowzaData = response.data.data;
                    // const wowzaOrigin = response.wowza;

                    // this.application = applicationData;
                    //this.wowzaData = wowzaData;
                    this.wowzaOrigin = response.wowza;
                    // this.OnpublishServer = 'rtmp://' + this.wowzaOrigin + '/' + this.application + '/';
                } else {
                    console.error('Error:', response.message);
                }
            } catch (error) {
                console.error('Error:', error);
            }
        },
        toggleSwitch(switchKey) {
            if (switchKey === 'recording' && !this.isLiveRunning()) {
                this.snackbar = true;
                this.snackbarText = this.$store.getters.t('메인 라이브를 먼저 시작한 후 녹화를 켤 수 있습니다.');
                this.snackbarError = true;
                setTimeout(() => {
                    this.snackbar = false;
                    this.snackbarError = false;
                    this.snackbarText = "";
                }, 2000);
                return;
            }
            this.switchStates[switchKey] = !this.switchStates[switchKey];
            //console.log(switchKey + " 스위치가 " + (this.switchStates[switchKey] ? '켜짐' : '꺼짐') + "으로 전환됨");
        },
        isLiveRunning() {
            const status = this.live_status;
            if (status === null || status === undefined || status === '') {
                return false;
            }
            if (typeof status === 'boolean') {
                return status;
            }
            const numeric = Number(status);
            if (!Number.isNaN(numeric)) {
                return numeric === 1;
            }
            const normalized = String(status).trim().toLowerCase();
            return normalized === 'live' || normalized === 'running' || normalized === 'on';
        },
        openChannelModal() {
            this.selectedPlatform = null
            this.isChannelModalOpen = true
            },
            selectPlatform(name) {
            this.selectedPlatform = name
            },
            async goNext() {
            this.isProceeding = true
            try {
                // 다음 단계로 진행: 예) OAuth 팝업/설정 폼 오픈 등
                await this.proceedChannelAdd(this.selectedPlatform)
                this.isChannelModalOpen = false
            } catch (e) {
                // 에러 핸들링 필요 시
                this.$emit('error', e)
            } finally {
                this.isProceeding = false
            }
            },
            // 실제 비즈니스 로직 연결 지점
            async proceedChannelAdd(platform) {
            // 예시: 플랫폼별 라우팅/폼 오픈/백엔드 API 토큰 교환 준비 등
            // if (platform === 'youtube') {...}
            // if (platform === 'instagram') {...}
            return Promise.resolve()
        }
    },
    async beforeMount() {
        const uuid = this.$route.params.uuid;
        await this.getApplication();
        await this.liveData(uuid);
        await this.pullStatus();
    },
    watch: {
        live_status(newStatus) {
            //console.log("newStatus", newStatus);
            if (Number(newStatus) === 1) {
                this.refreshIframe();
            }
        }
    }
}
</script>

<style scoped>
.video-container{
  position:relative;
  width:100%;
  padding-top:56.25%; /* 16:9 */
}
.video-container iframe{
  position:absolute;inset:0;width:100%;height:100%;
}

.uniform-gap-32 {
  margin-left: -16px;
  margin-right: -16px;
  /* 위아래도 동일 간격으로 맞추고 싶다면 아래 2줄도 추가
  margin-top: -16px;
  margin-bottom: -16px;
  */
}

/* 상위 두 컬럼만 정확히 타겟 */
.uniform-gap-32 > .grid-col {
  padding-left: 16px !important;
  padding-right: 16px !important;
  /* 위아래도 동일 간격
  padding-top: 16px !important;
  padding-bottom: 16px !important;
  */
}

/* 소셜미디어 데코 */
.sm-gradient-badge{
  width:32px;height:32px;border-radius:8px;
  background:linear-gradient(135deg,#ec4899,#8b5cf6);
  display:flex;align-items:center;justify-content:center;
}
.sm-status{
  border-radius:8px;background:#f9fafb;
}
.sm-logo{
  width:48px;height:48px;border-radius:12px;display:flex;align-items:center;justify-content:center;
}
.sm-logo.youtube{ background:#dc2626; }
.sm-logo.insta{ background:linear-gradient(135deg,#8b5cf6,#ec4899); }
.sm-logo.relative{ position:relative; }
.sm-alert-dot{
  position:absolute;top:-6px;right:-6px;width:20px;height:20px;border-radius:9999px;background:#f97316;
  display:flex;align-items:center;justify-content:center;
}

.sm-gradient-btn{
  background:linear-gradient(90deg,#8b5cf6,#ec4899) !important;
  color:#fff !important;
}

.live-dot{
  width:10px;height:10px;border-radius:9999px;background:#ef4444;
  animation:blink 1.2s infinite;
}
.status-dot{
  width:10px;height:10px;border-radius:9999px;background:#9ca3af;
}
@keyframes blink{ 0%,100%{opacity:1} 50%{opacity:.2} }

.url-info-list {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.url-block {
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid rgba(0,0,0,0.08);
  padding-bottom: 12px;

}

.url-block:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.url-label {
  font-weight: 700;
  font-size: 13px;
  color: #374151;
  margin-bottom: 6px;
}

.url-line {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding-left: 8px;
}

.url-text {
  flex: 1;
  font-size: 12.5px;
  color: #111827;
  word-break: break-all;
}

.mono-ellipsis {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", monospace;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.platform-selection {
    display:flex;
    flex-direction: column;
    gap: 12px;
}

.platform-item {
  padding: 16px;
  border-color: #e5e7eb !important; /* gray-200 */
  transition: .15s border-color ease, .15s box-shadow ease, .15s background-color ease;
  cursor: pointer;
}
.platform-item:hover {
  border-color: #ccc !important; /* hover 유사 */
  background: #f3f3f3;
  box-shadow: 0 6px 16px rgba(0,0,0,.05);
}
.platform-item.is-selected {
  border-color: #006cea !important; /* rose-400 */
  background: #ecf5ff;
}

.platform-icon {
  width: 48px; height: 48px; border-radius: 12px;
  display: flex; align-items: center; justify-content: center;
}
.platform-icon.youtube { background: #dc2626; }         /* red-600 */
.platform-icon.insta  { background: linear-gradient(135deg,#8b5cf6,#ec4899); }

@media(min-width: 768px) {
  .platform-selection {
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 12px;
  }
}

.info_alert span{
    font-size: 14px;
}

</style>
